import axios from "../utils/axios";

export const getAffiliateDiscount = async () => {
    const { data } = await axios.get("/affiliate-discount");
    return data;
};

export const getSubscription = async () => {
    const { data } = await axios.get("/vendor/subscription");
    return data;
};

//new
export const sendSubscription = async (req) => {

    const { data } = await axios.post('/vendor/subscription/new', req, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Accept": "application/json"
        },
    });

    return data;
};

//subscribe
export const sendSubscribe = async (req) => {
    const { data } = await axios.post('/vendor/subscription/subscribe', req, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Accept": "application/json"
        },
    });
    return data;
};

// renew subscribe
export const sendRenew = async () => {

    const { data } = await axios.post('/vendor/subscription/renew', {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Accept": "application/json"
        },
    });

    return data;
};

// get upgradeCost
export const getUpgradeCost = async (package_id, duration_id, package_type) => {
    const params = {
        package_id,
        duration_id,
        package_type,
    };
    const { data } = await axios.get('/vendor/subscription/upgradeCost', { params });
    return data;
};

// send upgradeCost
export const sendUpgrade = async (req) => {
    const { data } = await axios.post('/vendor/subscription/upgrade', req, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Accept": "application/json"
        },
    });
    return data;
};